import {
  CASAMAPA_ADMIN2_PORTAL_BASE,
  CASAMAPA_CLIENT_VIEW_SLUG,
  CASAMAPA_PARTNER_PORTAL_BASE,
  casamapaPartnerPortalPath,
  clientViewPartnerPortalBase,
  clientViewPartnerPortalPath,
} from "./clientViewPartnerPortalRoutes.js";

export {
  CASAMAPA_ADMIN2_PORTAL_BASE,
  CASAMAPA_CLIENT_VIEW_SLUG,
  CASAMAPA_PARTNER_PORTAL_BASE,
  casamapaPartnerPortalPath,
};

export const CASA_MAPA_PARTNER_PORTAL_TABS = Object.freeze([
  {
    segment: "dashboard",
    labelKey: "realEstate.casaMapa.admin.nav.dashboard",
    icon: "◆",
    navGroup: "primary",
    audiences: ["all"],
  },
  {
    segment: "leads",
    labelKey: "realEstate.casaMapa.admin.nav.leads",
    icon: "◈",
    navGroup: "primary",
    audiences: ["all"],
  },
  {
    segment: "listings",
    labelKey: "realEstate.casaMapa.admin.partnerListings.navLabel",
    icon: "▣",
    navGroup: "primary",
    audiences: ["agency"],
  },
  {
    segment: "market",
    labelKey: "realEstate.casaMapa.admin.nav.market",
    icon: "◐",
    navGroup: "primary",
    audiences: ["all"],
  },
  {
    segment: "directory",
    labelKey: "realEstate.casaMapa.admin.nav.directory",
    icon: "⌖",
    navGroup: "primary",
    audiences: ["vendor"],
  },
]);
